import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipIconComponent } from './tooltip-icon.component';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsTooltipModule } from '@cds/ng-web-components/tooltip';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@NgModule({
  imports: [CommonModule, CdsIconModule, CdsTooltipModule, CdsLanguageModule, TooltipIconComponent],
  exports: [TooltipIconComponent],
})
export class TooltipIconModule {}
